import styles from './style.m.less';

export default function NotificationsDotButton({ children = null }) {
    return <span className={styles.dot}>{children}</span>;
}
